import * as Sentry from "@sentry/react";
import { type PropsWithChildren } from "react";

import { SentryContext, type SentryContextValue } from "./sentry-context-value";
import { SentryErrorBoundary } from "./sentry-error-boundary";

export function SentryProvider({
  children,
  config,
  dev: { editor = "vscode", rootPath = "" },
  mode,
  environment = "Development",
  enableFeedback = false,
}: PropsWithChildren<
  Omit<SentryContextValue, "dev"> & {
    dev: Partial<SentryContextValue["dev"]>;
    enableFeedback?: boolean;
  }
>) {
  Sentry.init({
    integrations: [
      Sentry.browserTracingIntegration(),
      ...(enableFeedback
        ? [
            Sentry.feedbackIntegration({
              autoInject: false,
              enableScreenshot: true,
            }),
          ]
        : []),
    ],
    environment,
    enabled: mode === "Production" && config.dsn !== "",
    ...config,
  });

  return (
    <SentryContext.Provider
      value={{
        config,
        dev: { editor, rootPath },
        mode,
        environment,
        enableFeedback,
      }}
    >
      <SentryErrorBoundary feature="app" actions={null}>
        {children}
      </SentryErrorBoundary>
    </SentryContext.Provider>
  );
}
